<template>
    <div class="chart-container">
        <Doughnut :data="datachart" :options="chartoptions" />
    </div>
</template>

<script lang="ts">
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "vue-chartjs";

ChartJS.register(ArcElement, Tooltip, Legend);

export default {
    name: "Chart",
    props: {
        labels: {
            type: Array,
            required: false,
        },
        chardata: {
            type: Array,
            required: false,
        },
        charbackgroundcolor: {
            type: Array,
            required: false,
        },
        chartoptions: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },

    components: {
        Doughnut,
    },
    data() {
        return {
            datachart: {
                labels: [],
                datasets: [
                    {
                        backgroundColor: [
                            "#129B82",
                            "#F09F34",
                            "#346CF0",
                            "#DD1B16",
                        ],
                        data: [],
                    },
                ],
            },
        };
    },

    created() {
        //Set datasets
        if (Array.isArray(this.labels) && Array.isArray(this.chardata)) {
            Object.assign(this.datachart.labels, this.labels);
            Object.assign(this.datachart.datasets[0].data, this.chardata);

            if (Array.isArray(this.charbackgroundcolor)) {
                Object.assign(
                    this.datachart.datasets[0].backgroundColor,
                    this.charbackgroundcolor
                );
            }
        }
    },
    computed: {
        dataChartComputed() {
            return this.datachart;
        },
    },
    watch: {
        dataChartComputed() {},
    },
};
</script>
